import { render, staticRenderFns } from "./EscuelasDetalleContactos.vue?vue&type=template&id=05bac94e&"
import script from "./EscuelasDetalleContactos.vue?vue&type=script&lang=js&"
export * from "./EscuelasDetalleContactos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports